import React, { useState } from 'react';
import CustomCheckbox from '../../../../../../components/CustomCheckbox';

interface TagProps {
  name: string;
  id: string;
  onClick: (id: string) => void;
}

const SelectTag = ({ name, id, onClick }: TagProps) => {
  const [checked, setChecked] = useState<boolean>(false);

  const handleChange = () => {
    setChecked(!checked);
    onClick(id);
  };

  return (
    <CustomCheckbox
      id={id}
      checked={checked}
      onChange={handleChange}
      title={name}
    />
  );
};

export default SelectTag;
